// import FgInput from "./components/Inputs/FormGroupInput.vue";
// import DropDown from "./components/Dropdown.vue";
// import Card from "./components/Cards/Card.vue";
// import Button from "./components/Button.vue";
// import {
//   ElInput,
//   ElInputNumber,
//   ElTooltip,
//   ElPopover,
//   ElLoading,
// } from "element-plus";

// /**
//  * You can register global components here and use them as a plugin in your main Vue instance
//  */

// const GlobalComponents = {
//   install(app) {
//     app.component("drop-down", DropDown);
//     app.component("card", Card);
//     app.component("n-button", Button);
//     app.component(ElInput.name, ElInput);
//     app.component(ElInputNumber.name, ElInputNumber);
//     app.component("fg-input", FgInput);
//     app.use(ElTooltip);
//     app.use(ElPopover);
//     app.use(ElLoading);
//   },
// };

// export default GlobalComponents;

import FgInput from "./components/Inputs/FormGroupInput.vue";
import DropDown from "./components/Dropdown.vue";
import Card from "./components/Cards/Card.vue";
import Button from "./components/Button.vue";

import {
	ElInput,
	ElInputNumber,
	ElTooltip,
	ElPopover,
	ElLoading,
	ElDialog,
	ElForm,
	ElFormItem,
	ElMessage,
	ElSelect,
	ElOption,
	ElButton,
	ElUpload,
	ElTable,
	ElTableColumn,
} from "element-plus";

const GlobalComponents = {
	install(app) {
		app.component("drop-down", DropDown);
		app.component("card", Card);
		app.component("n-button", Button);
		app.component("fg-input", FgInput);

		// Register Element Plus components
		app.component(ElInput.name, ElInput);
		app.component(ElInputNumber.name, ElInputNumber);
		app.component(ElDialog.name, ElDialog);
		app.component(ElForm.name, ElForm);
		app.component(ElFormItem.name, ElFormItem);
		app.component(ElSelect.name, ElSelect);
		app.component(ElOption.name, ElOption);
		app.component(ElButton.name, ElButton);
		app.component(ElUpload.name, ElUpload);
		app.component(ElTable.name, ElTable);
		app.component(ElTableColumn.name, ElTableColumn);

		app.use(ElTooltip);
		app.use(ElPopover);
		app.use(ElLoading);

		app.config.globalProperties.$message = ElMessage;
	},
};

export default GlobalComponents;
